const API = 'UserCmsProfilePermissions';

export const API_USER_CMS_PROFILE_PERMISSIONS = {
  GET_ALL_DYNAMIC: `${API}/GetAllDynamic`,
  POST: `${API}/Create`,
  PATCH: (data: Pick<UserCmsProfilePermissions, 'id'>) => `${API}/Patch/${data.id}`,
  DELETE: (data: Pick<UserCmsProfilePermissions, 'id'>) => `${API}/Delete/${data.id}`,
};

export class UserCmsProfilePermissions {
  id!: string;
  isActive = true;
  title = '';
  isAllowToEditSetting = false;
  isAllowToEditLabels = false;
  isAllowToEditProfile = false;
  isAllowToEditCrmUsers = false;
  isAllowToEditPermissions = false;
  isAllowToViewLog = false;
  isAllowToViewSensitiveInformation = false;
  isAllowToResetSensitiveInformation = false;
}

export interface IUserCmsProfilePermissions extends UserCmsProfilePermissions {}
